import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Insurance } from '../_models/insurance.model';
import { QueryParamsModel } from '../../_base/crud';

export enum InsuranceActionTypes {
  AllInsurancesRequested = '[Insurances Module] All Insurances Requested',
  AllInsurancesLoaded = '[Insurances API] All Insurances Loaded',
  InsuranceOnServerCreated = '[Edit Insurance Component] Insurance On Server Created',
  InsuranceCreated = '[Edit Insurance Dialog] Insurance Created',
  InsuranceOnServerUpdated = '[Edit Insurance Dialog] Insurance On Server Updated',
  InsuranceUpdated = '[Edit Insurance Dialog] Insurance Updated',
  InsuranceOnServerDeleted = '[Insurances List Page] Insurance On Server Deleted',
  InsuranceDeleted = '[Insurances List Page] Insurance Deleted',
  InsurancesPageRequested = '[Insurances List Page] Insurances Page Requested',
  InsurancesPageLoaded = '[Insurances API] Insurances Page Loaded',
  InsurancesPageCancelled = '[Insurances API] Insurances Page Cancelled',
  InsurancesPageToggleLoading = '[Insurances] Insurances Page Toggle Loading',
  InsurancesActionToggleLoading = '[Insurances] Insurances Action Toggle Loading',
  ThrowInsuranceError = '[Insurances] ThrowInsuranceError',
  ClearInsuranceErrors = '[Insurances] ClearInsuranceErrors',
}

export class InsuranceOnServerCreated implements Action {
  readonly type = InsuranceActionTypes.InsuranceOnServerCreated;

  constructor(public payload: { insurance: Insurance }) {}
}

export class InsuranceCreated implements Action {
  readonly type = InsuranceActionTypes.InsuranceCreated;

  constructor(public payload: { insurance: Insurance }) {}
}

export class ThrowInsuranceError implements Action {
  readonly type = InsuranceActionTypes.ThrowInsuranceError;

  constructor(public payload: { error: any }) {}
}

export class ClearInsuranceErrors implements Action {
  readonly type = InsuranceActionTypes.ClearInsuranceErrors;
}

export class InsuranceOnServerUpdated implements Action {
  readonly type = InsuranceActionTypes.InsuranceOnServerUpdated;

  constructor(
    public payload: {
      partialInsurance: Update<Insurance>;
      insurance: Insurance;
    },
  ) {}
}

export class InsuranceUpdated implements Action {
  readonly type = InsuranceActionTypes.InsuranceUpdated;

  constructor(
    public payload: {
      partialInsurance: Update<Insurance>;
      insurance: Insurance;
    },
  ) {}
}

export class InsuranceOnServerDeleted implements Action {
  readonly type = InsuranceActionTypes.InsuranceOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class InsuranceDeleted implements Action {
  readonly type = InsuranceActionTypes.InsuranceDeleted;

  constructor(public payload: { id: number }) {}
}

export class InsurancesPageRequested implements Action {
  readonly type = InsuranceActionTypes.InsurancesPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class InsurancesPageLoaded implements Action {
  readonly type = InsuranceActionTypes.InsurancesPageLoaded;

  constructor(
    public payload: { insurances: Insurance[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class InsurancesPageCancelled implements Action {
  readonly type = InsuranceActionTypes.InsurancesPageCancelled;
}

export class InsurancesPageToggleLoading implements Action {
  readonly type = InsuranceActionTypes.InsurancesPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class InsurancesActionToggleLoading implements Action {
  readonly type = InsuranceActionTypes.InsurancesActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type InsuranceActions =
  | InsuranceCreated
  | InsuranceUpdated
  | InsuranceDeleted
  | InsuranceOnServerCreated
  | InsuranceOnServerUpdated
  | InsuranceOnServerDeleted
  | InsurancesPageLoaded
  | InsurancesPageCancelled
  | InsurancesPageToggleLoading
  | InsurancesPageRequested
  | InsurancesActionToggleLoading
  | ThrowInsuranceError
  | ClearInsuranceErrors;
